import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { showAddEditPerson, hideAddEditPerson } from '../store/actions/personDialog.actions';

export const usePersonDialog = () => {
  const dispatch = useDispatch();
  const savedResult = useSelector((state) => state.personDialog.savedResult);
  const pendingRequest = useRef(null);

  useEffect(() => {
    const request = pendingRequest.current;
    if (!request || savedResult?.requestId !== request.requestId || !savedResult.person) return;

    const callback = savedResult.isEditMode ? request.onPersonUpdated : request.onPersonCreated;
    callback?.(savedResult.person);
  }, [savedResult]);

  const openPersonDialog = useCallback(
    (personId = null, options = {}) => {
      const requestId = uuid();
      pendingRequest.current = { ...options, requestId };
      dispatch(
        showAddEditPerson({
          personId,
          requestId,
          closeOnSave: options.closeOnSave,
          origin: options.origin,
          initialMenuKey: options.initialMenuKey,
        })
      );
    },
    [dispatch]
  );

  const closePersonDialog = useCallback(
    (requestId = null) => dispatch(hideAddEditPerson(requestId)),
    [dispatch]
  );

  return { openPersonDialog, closePersonDialog };
};
